import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import ChartsSection from './ChartsSection';
import DetailedAnalytics from './DetailedAnalytics';
import Header from './Header';
import StatsGrid from './StatsGrid';

/**
 * Main Analytics Dashboard Component
 * Fetches and manages data, renders all dashboard sections
 */
const AnalyticsDashboard = () => {
  const [timeRange, setTimeRange] = useState('monthly');
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sample data - in a real app, this would come from an API
  const sampleData = {
    totalProperties: 1247,
    publishedProperties: 892,
    pendingProperties: 213,
    expiredProperties: 142,
    totalUsers: 562,
    blockedUsers: 38,
    totalPropertyViews: 12458,
    totalFavorites: 2873,
    totalStarRatings: 4562,
    visitorsData: {
      daily: [120, 145, 138, 165, 152, 180, 195],
      weekly: [850, 920, 780, 890, 950, 1020, 1100],
      monthly: [3200, 3500, 3800, 4200, 4500, 4800, 5100]
    },
    deviceData: {
      mobile: 62,
      desktop: 32,
      tablet: 6
    },
    countryData: [
      { country: __('United States', 'havenlytics'), visitors: 3245, percentage: 32 },
      { country: __('United Kingdom', 'havenlytics'), visitors: 1987, percentage: 20 },
      { country: __('Canada', 'havenlytics'), visitors: 1245, percentage: 12 },
      { country: __('Australia', 'havenlytics'), visitors: 987, percentage: 10 },
      { country: __('Germany', 'havenlytics'), visitors: 756, percentage: 8 }
    ],
    browserData: [
      { browser: __('Chrome', 'havenlytics'), users: 5240, percentage: 52 },
      { browser: __('Safari', 'havenlytics'), users: 1980, percentage: 20 },
      { browser: __('Firefox', 'havenlytics'), users: 1250, percentage: 12 },
      { browser: __('Edge', 'havenlytics'), users: 980, percentage: 10 },
      { browser: __('Other', 'havenlytics'), users: 550, percentage: 6 }
    ]
  };

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setStatsData(sampleData);
      setLoading(false);
    }, 1500);
  }, []);

  if (loading) {
    return (
      <div className="hvnly-container">
        <div className="hvnly-loading">
          <i className="fas fa-spinner fa-spin"></i>
          <p>{__('Loading analytics data...', 'havenlytics')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="hvnly-container">
      <Header timeRange={timeRange} setTimeRange={setTimeRange} />
      <StatsGrid statsData={statsData} />
      <ChartsSection statsData={statsData} timeRange={timeRange} />
      <DetailedAnalytics statsData={statsData} />
    </div>
  );
};

export default AnalyticsDashboard;